<template>
  <div :class="$setClasses">
    <nxt-core-resume v-if="demand"
                v-model="value"
                :disabled="disabled"
                :from-address="fromAddress"
                :from-date="clientLoadDate"
                :is-collapse="isCollapse === undefined ? true : isCollapse"
                :one-table="syncFormule"
                :to-address="toAddress"
                :to-date="clientDeliveryDate"
                :two-table="syncLeftToDo">
      <template v-slot:date-collapse-item>
        <slot name="collapse-items"></slot>
        <el-collapse-item v-if="insuranceData && !insuranceData.hidden"
                          :disabled="disabled || insuranceData.disabled"
                          name="insurance">
          <template v-if="isCollapse"
                    #title>
            <font-awesome-icon v-if="insuranceData.displayCheck"
                                :class="['resume__icon-check',
                                insuranceData.check ? '--is-check' : '']"
                                :icon="['fas',
                                insuranceData.check ? 'circle-check' : 'circle-xmark']"/>
            <font-awesome-icon v-if="insuranceData.icon !== false"
                                :class="'resume__icon'"
                                :icon="insuranceData.icon"/>
            <span :class="['resume__title', 'bold']">{{ insuranceData.title }}</span>
          </template>
          <nxt-core-table-card :class="$vClass('card')"
                          :hide-title="isCollapse"
                          :one-table="insuranceData"/>
        </el-collapse-item>
      </template>
      <template v-slot:after-collapse-item>
        <template v-if="offer">
          <el-collapse-item v-if="offerServices?.items?.length
            && !offerServices.hidden"
                            :disabled="disabled || offerServices.disabled"
                            name="services">
            <template v-if="isCollapse"
                      #title>
              <font-awesome-icon v-if="offerServices.displayCheck"
                                 :class="['resume__icon-check',
                                  offerServices.check ? '--is-check' : '']"
                                 :icon="['fas',
                                  offerServices.check ? 'circle-check' : 'circle-xmark']"/>
              <font-awesome-icon v-if="offerServices.icon !== false"
                                 :class="'resume__icon'"
                                 :icon="offerServices.icon || ['fal', 'truck']"/>
              <span :class="['resume__title', 'bold']">{{ offerServices.title }}</span>
            </template>
            <nxt-core-table-card :class="$vClass('card')"
                            :hide-title="isCollapse"
                            :one-table="offerServices">
            </nxt-core-table-card>
            <div v-if="chooseServices?.length"
                 :class="$vClass('wrapper__services')">
              <card-flex v-for="(item, index) in chooseServices"
                         :icon="['fal', item.icon]"
                         :key="`service_${index}`"
                         :title="item.title"
                         class="is-chosen-service --margin-top --icon-size-lg">
                <p>{{item.subtitle}}</p>
                <template v-slot:after>
                  <b>{{ formatPrice(item.step
                      ? (item.value_chosen || 0) / item.step * item[priceType]
                      : item[priceType], priceTypeKey) }}</b>
                </template>
              </card-flex>
            </div>
          </el-collapse-item>
          <el-collapse-item v-if="offerOptions?.items?.length
            && !offerOptions.hidden"
                            :disabled="disabled || offerOptions.disabled"
                            name="options">
            <template v-if="isCollapse"
                      #title>
              <font-awesome-icon v-if="offerOptions.displayCheck"
                                 :class="['resume__icon-check',
                                  offerOptions.check ? '--is-check' : '']"
                                 :icon="['fas',
                                  offerOptions.check ? 'circle-check' : 'circle-xmark']"/>
              <font-awesome-icon v-if="offerOptions.icon !== false"
                                 :class="'resume__icon'"
                                 :icon="offerOptions.icon || ['fal', 'truck']"/>
              <span :class="['resume__title', 'bold']">{{ offerOptions.title }}</span>
            </template>
            <nxt-core-table-card :class="$vClass('card')"
                            :hide-title="isCollapse"
                            :one-table="offerOptions"
                            @option-change-checkbox="handlerUpdateOption">
              <template v-if="!hidePriceInfo" v-slot:before-checkbox="{item}">
                <span :class="$vClass('option-price')">
                  <span v-if="hasOptionDiscount"
                        :class="$vClass('option-price__before')">
                    {{ $n(getOptionPriceBeforeDiscount(item), 'currency') }}
                  </span>
                  <span :class="$vClass('option-price__current')">
                    {{ $n(getPrice(item), 'currency') }}
                    {{ $t('base.priceType', priceTypeKey) }}
                  </span>
                </span>
              </template>
            </nxt-core-table-card>
          </el-collapse-item>
        </template>
      </template>
    </nxt-core-resume>
    <slot name="before-price"></slot>
    <total v-if="!hideTotalPrice && !hidePriceInfo && offer"
           :class="[$vClass('total'), '--margin-top']"
           :is-box="isBox"
           :offer="offer"
           :original-price="priceBeforeDiscountWithServices"
           :price="priceWithServices"
           :partner-discount-rate="partnerDiscountRate"
           :show-partner-discount="hasPartnerDiscount"
           :warning-price="!!warningVisible">
      <template v-if="isBox"
                v-slot:price="{ formattedDiscountAmount, formattedOriginalPrice, formattedPrice, hasPartnerDiscount }">
        <p :class="[$vClass('price'), 'total__price']">
          {{ formattedPrice }}
        </p>
        <p v-if="hasPartnerDiscount"
           :class="[$vClass('price__before'), 'total__before-price']">
          {{ formattedOriginalPrice }}
        </p>
        <p v-if="hasPartnerDiscount"
           :class="[$vClass('price__saving'), 'total__saving']">
          {{ $t('resume.partnerDiscount.savingLabel') }}
          <span :class="$vClass('price__saving__amount')">{{ formattedDiscountAmount }}</span>
        </p>
        <p>{{ $t('resume.booking.guaranteedPrice') }}</p>
        <!--        <nxt-core-link v-if="offer.url"-->
        <!--                  :class="$vClass('price__link')"-->
        <!--                  :to="offer.url"-->
        <!--                  target="_blank">{{ $t('resume.booking.seePdf') }}</nxt-core-link>-->
      </template>
    </total>
  </div>
</template>

<script>
import { computed } from 'vue';
import { mapState, mapActions } from 'pinia';
import CardFlex from '@/utils/components/CardFlex.vue';
import Total from '@/utils/components/Total.vue';
import offersHelper from '@/utils/helpers/offers';
import { useConfigStore, useOfferStore } from '@/stores';
import { useMoveManagerEmits, useMoveManager, useMoveManagerProps } from '@/composables/useMoveManager';

export default {
  name: 'quote',
  nameClassStyle: 'quote',
  emits: useMoveManagerEmits,
  setup(props, { emit }) {
    const context = useMoveManager(props, { emit });
    context.price = computed(() => offersHelper.getPrice(props.offer, context.demand.value.show_price_ht));
    context.priceBeforeDiscount = computed(() => offersHelper.getPriceBeforeDiscount(
      props.offer,
      context.demand.value.show_price_ht,
    ));
    context.priceWithServices = computed(() => context.price.value + context.servicesPrice.value);
    context.priceBeforeDiscountWithServices = computed(() => (
      context.priceBeforeDiscount.value + context.servicesPrice.value
    ));
    context.hasPartnerDiscount = computed(() => offersHelper.hasPartnerDiscount(props.offer));
    context.partnerDiscountRate = computed(() => offersHelper.getPartnerDiscountRate(props.offer));
    context.hasOptionDiscount = computed(() => context.partnerDiscountRate.value > 0);
    context.getPrice = (option) => context.exclTax.value ? option.price_ht : option.price;
    context.getOptionPriceBeforeDiscount = (option) => offersHelper.getOptionPriceBeforeDiscount(
      option,
      props.offer,
      context.exclTax.value,
    );
    context.chosenOptions = computed(() => {
      return props.offer?.options && {
        items: props.offer.options.filter((opt) => opt.is_chosen),
        ...context.chosenOptionsInfos.value,
      };
    });
    context.options = computed(() => {
      return props.offer?.options && {
        items: props.offer.options,
        ...context.optionsInfos.value,
        check: !!(props.offer.options.find((opt) => opt.is_chosen)),
        displayCheck: true,
        checkbox: props.checkboxOptions,
        ...props.collapseItems.options,
      };
    });
    context.offerOptions = computed(() => {
      const options = props.optionsType === 'chosen' ? context.chosenOptions.value : context.options.value;
      return {
        ...options,
        displayCheck: true,
        check: options.items.find((item) => item.is_chosen),
      };
    });
    return context;
  },
  components: {
    CardFlex,
    Total,
  },
  props: {
    ...useMoveManagerProps,
    hideInfoMover: Boolean,
    hideTotalPrice: Boolean,
    isBox: Boolean,
    isCollapse: Boolean,
    disabled: Boolean,
    modelValue: Array,
    checkboxOptions: Boolean,
    optionsType: String,
    collapseItems: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      value: this.modelValue,
    };
  },
  computed: {
    ...mapState(useConfigStore, ['comparatorConfig']),
    chooseServices() {
      return this.servicesStore.filter((item) => (item.is_chosen));
    },
    syncLeftToDo() {
      return {
        ...this.leftToDo,
        displayCheck: true,
      };
    },
    syncFormule() {
      return {
        ...this.formule,
        displayCheck: true,
        check: true,
        ...this.collapseItems.formule,
      };
    },
    fromAddress() {
      return {
        ...this.demand.from_address,
        displayCheck: true,
        check: !!(this.demand.from_address?.street),
        ...this.collapseItems.fromAddress,
      };
    },
    toAddress() {
      return {
        ...this.demand.to_address,
        displayCheck: true,
        check: !!(this.demand.to_address?.street),
        ...this.collapseItems.toAddress,
      };
    },
    offerServices() {
      return this.offer?.services && {
        items: this.offer.services,
        ...this.servicesInfos,
        displayCheck: true,
        check: true,
        ...this.collapseItems.services,
      };
    },
    insuranceData() {
      if (this.offer?.assurance_type === 'AUCUNE') {
        return null;
      }
      return this.offer?.assurance && this.offer?.franchise && {
        items: [this.offer.assurance, this.offer.franchise],
        ...this.insuranceInfos,
        displayCheck: true,
        check: true,
        ...this.collapseItems.insurance,
      };
    },
  },
  methods: {
    ...mapActions(useOfferStore, ['updateOption']),
    formatPrice(price, priceType) {
      return `${this.$n(price, 'currency')} ${this.$t('base.priceType', priceType)}`;
    },
    handlerUpdateOption({ item }) {
      const findIndex = this.offer.options.findIndex((option) => option.id === item.id);
      if (findIndex !== -1) {
        this.offer.options[findIndex].is_chosen = !this.offer.options[findIndex].is_chosen;
      }
      this.updateOption({ offerId: this.offer.id, optionId: item.id });
    },
  },
};
</script>

<style scoped lang="scss">
.quote {
  &__price__before,
  :deep(.total__before-price) {
    margin: 6px 0 0;
    color: var(--nxt-color-grey);
    font-size: 18px;
    font-weight: 600;
    text-decoration: line-through;
  }

  &__price__saving,
  :deep(.total__saving) {
    margin: 12px 0 0;
    color: var(--nxt-color-primary);
    font-size: 14px;
    font-weight: 700;
  }

  &__price__saving__amount {
    color: var(--nxt-color-warning);
  }

  &__option-price {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: baseline;
    justify-content: flex-end;
    gap: 4px;
  }

  &__option-price__before {
    color: var(--nxt-color-grey);
    font-size: 12px;
    text-decoration: line-through;
  }
}
</style>

<style lang="scss" scoped>
@use '@nextories/vue-core-components/src/assets/scss/components/templates/NxtCoreResume' as *;

.quote {
  @include breakpoint(tablet) {
    .quote__wrapper {
      display: flex;
      align-items: center;

      &__title:not(:last-child) :after {
        content: '-';
        display: block;
        padding: 0 15px;
      }
    }
  }

  &__total {
    padding-bottom: 20px;
  }

  &__price {
    font-size: 26px;

    &__link {
      color: var(--nxt-color-primary);
      font-weight: normal;
      text-shadow: none;
    }
  }

  .total__price {
    margin: 0;
    font-size: 30px;
    font-weight: 700;
  }

  .--margin-top:not(.is-chosen-service:first-child) {
    margin-top: 20px;
  }

  .--icon-size-lg {
    :deep(.card-flex__icon) {
      font-size: 30px;
    }
  }

  &__card {
    margin-bottom: 20px;
  }

  :deep(.card-flex__title) {
    font-size: 22px;
  }

  :deep(.card-flex__content), :deep(.card-flex__wrapper) {
    font-size: 18px;
  }

  .loading {
    position: absolute;
    top: 0;
    left: 0;
  }

  :deep(.card-flex__img) {
    height: 100px;
  }

  :deep(.table__item__icon.fa-times-circle),
  :deep(.table__item__icon.fa-circle-xmark) {
    color: var(--nxt-color-danger);
  }
}

.loader {

  .loading-icon {
    :deep(.bar) {
      background: var(--nxt-color-secondary);
    }
  }
}
</style>
